import { OnboardingFormSubmissionsList } from '@/components/OnboardingFormSubmissionsList';
import { OnboardingFormTemplatesList } from '@/components/OnboardingFormTemplatesList';
import TabLayout from '@/components/TabLayout';
import React from 'react';
import { Link, useLocation } from 'react-router';
import { Menu } from 'semantic-ui-react';

export const OnboardingForms = () => {
  const { pathname } = useLocation();

  return (
    <TabLayout
      linkTitle="Onboarding Forms"
      panes={panes}
      path={pathname}
      activeBreadcrumb="Onboarding Forms"
    />
  );
};

const panes = [
  {
    route: 'templates',
    menuItem: (
      <Menu.Item as={Link} to="/onboarding/forms/templates" key="templates">
        Templates
      </Menu.Item>
    ),
    render: () => <OnboardingFormTemplatesList />,
  },
  {
    route: 'submissions',
    menuItem: (
      <Menu.Item as={Link} to="/onboarding/forms/submissions" key="submissions">
        Submissions
      </Menu.Item>
    ),
    render: () => <OnboardingFormSubmissionsList />,
  },
];
